'use client'
import { homeCategoriesQueryOption, homeRobotQueryOption } from "@/apis/query/home"
import { useQueryPush } from "@/hooks/useQueryPush"
import { useUserStore } from "@/store/useUserStore"
import { isServer, useInfiniteQuery, useSuspenseQuery } from "@tanstack/react-query"
import { useTranslations } from "next-intl"
import { useMemo } from "react"
import { RobotList } from "../(home)/_components/RobotList"
import { TagSelector } from "../(home)/_components/TagSelector"
import RobotListLoading from "./RobotListLoading"

export const HomePage = ({ isHydration, defaultTags, locale }: {
  isHydration: any
  locale: string
  defaultTags: any
}) => {
  const t = useTranslations()
  const [isPending, push] = useQueryPush()
  const isLogined = useUserStore(state => state.isLogined)

  const categories = useSuspenseQuery(homeCategoriesQueryOption({ locale }))
  const tags = useMemo(() => {
    if (categories.data?.data.data) {
      const list = [...categories.data?.data.data.filter(item => item.cid !== 0)]
      if (isLogined) {
        list.unshift({ cid: 0, name: t('common.follow') })
      }
      return list
    } else {
      return []
    }
  }, [categories.data, isLogined])

  const robotInfiniteList = useInfiniteQuery(homeRobotQueryOption({ categories: defaultTags as any, locale }))

  return (
    <>
      <TagSelector className="mt-4 sm:mt-6" transitionPush={push} tags={tags}></TagSelector>
      {
        isPending || (!isHydration && isServer) || robotInfiniteList.isPending ?
          <RobotListLoading /> :
          <RobotList {...robotInfiniteList} />
      }

    </>
  )
}